import { useState } from 'react';
import styles from './SupportPage.module.css';

export default function SupportPage() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);

  const handle = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    setSending(true);
    // mailto fallback — opens email client
    const mailto = `mailto:support@vendly.com?subject=${encodeURIComponent(form.subject)}&body=${encodeURIComponent(`Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`)}`;
    window.location.href = mailto;
    setTimeout(() => { setSending(false); setSent(true); }, 800);
  };

  const TG_USERNAME = 'talkiddd';
  const TG_URL = `https://t.me/${TG_USERNAME}`;

  return (
    <div className={styles.page}>
      <div className={`container ${styles.layout}`}>

        {/* Left — info */}
        <div className={styles.info}>
          <div className={styles.infoHeader}>
            <span className={styles.infoIcon}>🎧</span>
            <div>
              <h1 className={styles.infoTitle}>We're here to help</h1>
              <p className={styles.infoSub}>Our support team responds within 24 hours</p>
            </div>
          </div>

          <div className={styles.channels}>
            {/* Telegram */}
            <a href={TG_URL} target="_blank" rel="noreferrer" className={styles.channelCard}>
              <div className={styles.channelIcon} style={{ background: '#229ED9' }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.248l-2.04 9.613c-.153.681-.555.849-1.124.528l-3.1-2.285-1.496 1.44c-.165.165-.304.304-.624.304l.222-3.156 5.74-5.185c.249-.222-.054-.345-.386-.123L7.06 14.316l-3.07-.957c-.666-.208-.68-.666.14-.986l11.99-4.623c.555-.2 1.041.136.442.498z"/>
                </svg>
              </div>
              <div className={styles.channelInfo}>
                <p className={styles.channelName}>Message on Telegram</p>
                <p className={styles.channelDesc}>@{TG_USERNAME} · Fastest response</p>
              </div>
              <span className={styles.channelArrow}>→</span>
            </a>

            {/* Email */}
            <a href="mailto:support@vendly.com" className={styles.channelCard}>
              <div className={styles.channelIcon} style={{ background: '#E8420A' }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
                </svg>
              </div>
              <div className={styles.channelInfo}>
                <p className={styles.channelName}>Email support</p>
                <p className={styles.channelDesc}>support@vendly.com · Within 24hrs</p>
              </div>
              <span className={styles.channelArrow}>→</span>
            </a>

            {/* WhatsApp */}
            <a href="https://wa.me/2348000000000" target="_blank" rel="noreferrer" className={styles.channelCard}>
              <div className={styles.channelIcon} style={{ background: '#25D366' }}>
                <svg width="22" height="22" viewBox="0 0 24 24" fill="white">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
              </div>
              <div className={styles.channelInfo}>
                <p className={styles.channelName}>WhatsApp</p>
                <p className={styles.channelDesc}>+234 800 000 0000 · Mon–Fri 9am–6pm</p>
              </div>
              <span className={styles.channelArrow}>→</span>
            </a>
          </div>

          <div className={styles.faq}>
            <h3 className={styles.faqTitle}>Common questions</h3>
            {[
              { q: 'How do I track my order?', a: 'Go to My Orders in your account to see real-time delivery status.' },
              { q: 'How long does delivery take?', a: 'Lagos same-day, other cities 1–3 business days.' },
              { q: 'How do I return a product?', a: 'Go to My Orders, select the order and click "Request return" within 7 days.' },
              { q: 'Is my payment secure?', a: 'Yes — all payments are processed by Paystack, Nigeria\'s most trusted payment gateway.' },
            ].map(({ q, a }) => (
              <details key={q} className={styles.faqItem}>
                <summary className={styles.faqQ}>{q}</summary>
                <p className={styles.faqA}>{a}</p>
              </details>
            ))}
          </div>
        </div>

        {/* Right — email form */}
        <div className={styles.formCard}>
          {sent ? (
            <div className={styles.sentState}>
              <span className={styles.sentIcon}>✅</span>
              <h3 className={styles.sentTitle}>Message sent!</h3>
              <p className={styles.sentSub}>Your email client should have opened. We'll reply within 24 hours.</p>
              <p className={styles.sentOr}>For faster help:</p>
              <a href={TG_URL} target="_blank" rel="noreferrer" className={styles.tgBtn}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.248l-2.04 9.613c-.153.681-.555.849-1.124.528l-3.1-2.285-1.496 1.44c-.165.165-.304.304-.624.304l.222-3.156 5.74-5.185c.249-.222-.054-.345-.386-.123L7.06 14.316l-3.07-.957c-.666-.208-.68-.666.14-.986l11.99-4.623c.555-.2 1.041.136.442.498z"/>
                </svg>
                Message @{TG_USERNAME} on Telegram
              </a>
              <button className={styles.resetBtn} onClick={() => { setSent(false); setForm({ name:'', email:'', subject:'', message:'' }); }}>
                Send another message
              </button>
            </div>
          ) : (
            <>
              <h2 className={styles.formTitle}>Send us a message</h2>
              <p className={styles.formSub}>Fill the form or reach us directly via Telegram for the fastest response.</p>

              <a href={TG_URL} target="_blank" rel="noreferrer" className={styles.tgBannerBtn}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                  <path d="M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0zm5.562 8.248l-2.04 9.613c-.153.681-.555.849-1.124.528l-3.1-2.285-1.496 1.44c-.165.165-.304.304-.624.304l.222-3.156 5.74-5.185c.249-.222-.054-.345-.386-.123L7.06 14.316l-3.07-.957c-.666-.208-.68-.666.14-.986l11.99-4.623c.555-.2 1.041.136.442.498z"/>
                </svg>
                Message @{TG_USERNAME} on Telegram — fastest response
              </a>

              <div className={styles.orDivider}><span>or send an email</span></div>

              <form className={styles.form} onSubmit={submit}>
                <div className={styles.row}>
                  <div className={styles.field}>
                    <label className={styles.label}>Your name</label>
                    <input className={styles.input} name="name" placeholder="John Doe" value={form.name} onChange={handle} required />
                  </div>
                  <div className={styles.field}>
                    <label className={styles.label}>Email address</label>
                    <input className={styles.input} type="email" name="email" placeholder="you@example.com" value={form.email} onChange={handle} required />
                  </div>
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>Subject</label>
                  <select className={styles.input} name="subject" value={form.subject} onChange={handle} required>
                    <option value="">Select a topic…</option>
                    <option>Order issue</option>
                    <option>Payment problem</option>
                    <option>Return / Refund</option>
                    <option>Account issue</option>
                    <option>Product question</option>
                    <option>Other</option>
                  </select>
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>Message</label>
                  <textarea
                    className={`${styles.input} ${styles.textarea}`}
                    name="message"
                    placeholder="Describe your issue in detail…"
                    value={form.message}
                    onChange={handle}
                    required
                    rows={5}
                  />
                </div>
                <button className={styles.submitBtn} type="submit" disabled={sending}>
                  {sending ? <span className={styles.spinner} /> : 'Send message'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
